export enum OverlayType {
  channel_create = 'channel_create',
  paywall_confirm_delete = 'paywall_confirm_delete',
  outlet_confirm_delete = 'outlet_confirm_delete',
  file_update_confirm = 'file_update_confirm',
}
